<template>
  <div class="account-info">
    <bar :my-title="account.name"></bar>
    <div class="swipe">
      <van-swipe :autoplay="3000" :show-indicators="false">
        <van-swipe-item v-for="(image, index) in slides" :key="index">
          <div @click="goUrl(image)" style="width: calc(100vw - 24px); height: 144px; position: relative;">
            <van-image :src="imageView(image.poster)" fit="contain"
              style="border-radius: 8px; overflow: hidden; width: 100%; height: 184px;" />
            <div class="time" v-if="image.time > 0 && image.regEndDate">
              <div class="info">距离报名结束仅剩</div>
              <div class="info">
                <div class="left-time">{{ image.day }}</div>&nbsp;天&nbsp;
                <div class="left-time">{{ image.hour }}</div>&nbsp;时&nbsp;
                <div class="left-time">{{ image.minute }}</div>&nbsp;分&nbsp;
                <div class="left-time">{{ image.second }}</div>&nbsp;秒&nbsp;
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="tabs">
      <div class="tab" @click="goNextPage('news')">
        <div class="logo">
          <img src="../../assets/news.png" style="width: 36px; height: 36px;" alt="">
        </div>
        <div style="height: 9px;"></div>
        <div class="info">新闻公告</div>
      </div>
      <div class="tab" @click="goNextPage('match-entry')">
        <div class="logo">
          <img src="../../assets/match-entry.png" style="width: 36px; height: 36px;" alt="">
        </div>
        <div style="height: 9px;"></div>
        <div class="info">赛事报名</div>
      </div>
      <div class="tab" @click="goNextPage('my-entry-list')">
        <div class="logo">
          <img src="../../assets/my-entry.png" style="width: 36px; height: 36px;" alt="">
        </div>
        <div style="height: 9px;"></div>
        <div class="info">我的参赛</div>
      </div>
      <div class="tab" @click="goNextPage('about-us')">
        <div class="logo">
          <img src="../../assets/about-us.png" style="width: 36px; height: 36px;" alt="">
        </div>
        <div style="height: 9px;"></div>
        <div class="info">关于我们</div>
      </div>
    </div>
    <div class="tabs">
      <div class="tab" @click="goAds(0)">
        <div class="logo">
          <img src="../../assets/ads/match-record.png" style="width: 36px; height: 36px;" alt="">
        </div>
        <div style="height: 9px;"></div>
        <div class="info">赛事直播</div>
      </div>
      <div class="tab" @click="goAds(1)">
        <div class="logo">
          <img src="../../assets/ads/sport.png" style="width: 36px; height: 36px;" alt="">
        </div>
        <div style="height: 9px;"></div>
        <div class="info">运动保障</div>
      </div>
      <div class="tab" @click="goAds(2)">
        <div class="logo">
          <img src="../../assets/ads/sport-equip.png" style="width: 36px; height: 36px;" alt="">
        </div>
        <div style="height: 9px;"></div>
        <div class="info">运动装备</div>
      </div>
      <div class="tab" @click="goAds(3)">
        <div class="logo">
          <img src="../../assets/ads/data.png" style="width: 36px; height: 36px;" alt="">
        </div>
        <div style="height: 9px;"></div>
        <div class="info">数据统计</div>
      </div>
    </div>
    <div class="match-list">
      <!--      <div class="title">-->
      <!--        <img src="../../assets/match.png" style="width: 16px; height: 16px; margin-right: 8px">-->
      <!--        <span>赛事列表</span>-->
      <!--      </div>-->
      <div class="tags">
        <div class="tag" :class="activeIndex === 0 ? 'selected' : 'normal'" @click="changeType(0)">全部</div>
        <div class="tag" :class="activeIndex === 2 ? 'selected' : 'normal'" @click="changeType(2)">报名中</div>
        <div class="tag" :class="activeIndex === 5 ? 'selected' : 'normal'" @click="changeType(5)">进行中</div>
        <div class="tag" :class="activeIndex === 6 ? 'selected' : 'normal'" @click="changeType(6)">已完赛</div>
      </div>
      <div class="list">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了"
          @load="getCrmAccountUnionMatchList(activeIndex)">
          <div class="item" v-for="(item, index) in list" :key="index" @click="goMatch(item.id)">
            <div class="bgi">
              <img :src="imageView(item.backgroundImage2, 0, 0)" />
              <div class="status">{{ item.state }}</div>
              <div class="t1">
                {{ item.chineseName }}
              </div>
            </div>
            <div class="match-info">
              <div class="location" v-if="item.location">{{ `${item.location}` }}</div>
              <div class="time">
                比赛时间：{{ getFormatDate(item.beginDate) }}-{{ getFormatDate(item.endDate) }}
                <img src="../../assets/grey-right.png" style="width: 13px; height: 13px;">
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import { Swipe, SwipeItem, Image as VanImage, Tag, List } from 'vant'
Vue.use(Swipe).use(SwipeItem).use(VanImage).use(Tag).use(List)
import Bar from '@/components/Bar'
import {
  getCrmAccountHome,
  getCrmAccountUnionMatchList
} from '@/api/match'
import { DateUtil, QNImageUtil, RegExpr } from '@/utils'

const ads = [
  'https://www.snsports.cn/webapp-bmb-stage/index.html#/videoService',
  'https://www.snsports.cn/insure/index/index.html#/home',
  'https://www.snsports.cn/webapp-bmb-stage/index.html#/team-style',
  'https://www.snsports.cn/webapp-stage/index.html?redirect=match-service&type=stats',
]

const titles = [
  '赛事直播',
  '运动保障',
  '运动装备',
  '数据统计'
]
export default {
  components: {
    Bar
  },
  data() {
    return {
      account: {},
      slides: [],
      list: [],
      accountId: '',
      activeIndex: 0,
      finished: false,
      loading: false,
      pageSize: 10,
      pageNum: 1,
      isRequest: false
    }
  },
  mounted() {
    this.accountId = this.$route.params.accountId
    this.getCrmAccountUnionMatchList(0)
    this.getCrmAccountHome()
  },
  methods: {
    goAds(index) {
      // const a = document.createElement('a')
      // a.href = ads[index]
      // a.target = '_blank'
      // document.body.append(a)
      // a.click()
      // document.body.removeChild(a)
      const params = {
        src: ads[index],
        title: titles[index]
      }
      localStorage.setItem('ads', JSON.stringify(params))
      this.$router.push(`/account/ads-iframe`)
    },
    goUrl(item) {
      if (RegExpr.checkNum(item.url)) {
        if (item.regEndDate && new Date().getTime() < new Date().getTime(item.regEndDate)) {
          this.$router.push('/entry-page?unionMatchId=' + item.url)
        } else {
          this.$router.push('/union-match?unionMatchId=' + item.url)
        }
      } else if (/\S+/.test(item.url)) {
        if (/^[http://|https://]\S+/.test(item.url)) window.location.href = item.url
        else window.location.href = 'http://' + item.url
      }
    },
    changeType(state) {
      this.list = []
      this.pageNum = 1
      this.getCrmAccountUnionMatchList(state)
    },
    getCrmAccountHome() {
      const params = {
        accountId: this.accountId
      }
      getCrmAccountHome(params).then(res => {
        const { data } = res
        this.account = data.account || {}
        this.slides = data.slides || []
        document.title = this.account.name
        const shareObj = {
          title: this.account.name,
          abstract: this.account.remark,
          image: QNImageUtil.imageView(this.account.logo)
        }
        this.wxShare(shareObj)
        this.updateTime()
      })
    },
    updateTime() {
      setInterval(() => {
        const slides = JSON.parse(JSON.stringify(this.slides))
        slides.forEach(item => {
          if (item.time > 0 && item.regEndDate) {
            let day = 0, hour = 0, minute = 0, second = 0
            let currentTime = new Date().getTime()
            let matchTime = new Date(item.regEndDate).getTime()
            let leftTime = 0
            if (currentTime < matchTime) {
              leftTime = matchTime - currentTime
              day = Math.floor(leftTime / 1000 / 3600 / 24)
              leftTime = leftTime - day * 1000 * 3600 * 24
              hour = Math.floor(leftTime / 1000 / 3600)
              leftTime = leftTime - hour * 1000 * 3600
              minute = Math.floor(leftTime / 1000 / 60)
              leftTime = leftTime - minute * 1000 * 60
              second = Math.floor(leftTime / 1000)
            }
            item.day = day >= 10 ? day : '0' + day
            item.hour = hour >= 10 ? hour : '0' + hour
            item.minute = minute >= 10 ? minute : '0' + minute
            item.second = second >= 10 ? second : '0' + second
          }
        })
        this.slides = slides
      }, 1000)
    },
    getCrmAccountUnionMatchList(state) {
      if (this.isRequest) return
      this.isRequest = true
      this.activeIndex = state
      const params = {
        accountId: this.accountId,
        state: state,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      getCrmAccountUnionMatchList(params).then(res => {
        if (res) {
          this.pageNum++
          const { data } = res
          const list = data.list || []
          this.list = this.list.concat(list)
          if (this.list.length < this.pageSize) {
            this.finished = true
          }
          this.isRequest = false
          this.$forceUpdate()
        }
      })
    },
    imageView(img, w = '', h) {
      if (!img) return ''
      if (w === 'default') w = window.innerWidth - 24
      return QNImageUtil.imageView(img, w, h)
    },
    goNextPage(type) {
      if (type === 'news') {
        this.$router.push('/account/news-list/' + this.accountId)
      } else if (type === 'match-entry') {
        this.$router.push('/account/entry-list/' + this.accountId)
      } else if (type === 'my-entry-list') {
        this.$router.push('/account/my-entry-list/' + this.accountId)
      } else if (type === 'about-us') {
        this.$router.push('/account/about-us/' + this.accountId)
      }
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}/{m}/{d}')
    },
    goMatch(id) {
      this.$router.push(`/union-match/match-overall?unionMatchId=${id}`)
    }
  }
}
</script>

<style scoped lang="scss">
.account-info {
  min-height: 100vh;
  background-color: #F6F6F8;

  .swipe {
    padding: 12px 12px 26px 12px;
    background-image: linear-gradient(#E7EFFE, #FFFFFF);

    .time {
      position: absolute;
      height: 36px;
      width: 100%;
      bottom: 0;
      border-radius: 0 0 8px 8px;
      background-color: #FF5F1C;
      opacity: 0.8;
      padding: 0 16px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        display: flex;
        color: #FFFFFF;
        font-weight: 500;
        font-size: 14px;
        align-items: center;

        .left-time {
          width: 24px;
          height: 24px;
          line-height: 24px;
          background-color: #9F3909;
          text-align: center;
          border-radius: 2px;
        }
      }
    }
  }

  .tabs {
    height: 94px;
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FFFFFF;

    .tab {
      width: 74px;

      .logo {
        margin: 0 auto;
        width: 36px;
        height: 36px;
        background-color: #F8F8F8;
        border-radius: 2px;
      }

      .info {
        height: 17px;
        line-height: 17px;
        font-size: 12px;
        color: #191919;
        text-align: center;
      }
    }
  }

  .match-list {
    padding: 0 12px;
    margin-top: 12px;
    background-color: #FFFFFF;

    .title {
      height: 49px;
      color: #191919;
      font-size: 16px;
      font-weight: bolder;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px #F2F2F2 solid;
    }

    .tags {
      padding: 12px 32px 16px 32px;
      display: flex;
      justify-content: space-between;

      .tag {
        width: 63px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 4px;
      }

      .selected {
        background-color: #1565FC;
        font-size: 12px;
        font-weight: 500;
        color: #FFFFFF;
      }

      .normal {
        background-color: #F3F7FF;
        font-size: 12px;
        color: #1565FC;
      }
    }

    .list {
      .item {
        .bgi {
          position: relative;
          border-radius: 4px;
          overflow: hidden;
          height: 143px;
          background-size: 100% 100%;

          img {
            height: 100%;
            width: 100%;
          }

          .status {
            position: absolute;
            top: 0;
            left: 0;
            width: 50px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            background-color: #12DB63;
            color: #FFFFFF;
            font-size: 12px;
            border-radius: 4px 0 4px 0;
          }

          .t1 {
            position: absolute;
            bottom: 0px;
            width: 100%;
            padding: 8px;
            box-sizing: border-box;
            background-color: rgba($color: #7F7F7F, $alpha: .5);
            color: #FFFFFF;
            font-size: 14px;
            padding-left: 12px;
          }
        }

        .match-info {
          height: 44px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .location {
            width: 92px;
            height: 24px;
            line-height: 24px;
            background-color: #E7EFFE;
            border-radius: 4px;
            color: #1565FC;
            font-size: 11px;
            text-align: center;
            overflow: hidden;
            text-wrap: none;
          }

          .time {
            color: #8C8C8C;
            font-size: 13px;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
